import React, { useState } from 'react';

import { Position } from 'coreOld/enums';

import TooltipView from './TooltipView';

interface IProps {
  position?: Position;
  text: string | JSX.Element;
  children?: React.ReactNode;
  tooltipOpacity?: number;
  backgroundColor?: string;
}

const Tooltip = ({ position, text, children, tooltipOpacity = 0.92, backgroundColor }: IProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const showTooltip = isHovered;

  return (
    <TooltipView
      position={position || Position.BOTTOM}
      text={text}
      showTooltip={showTooltip}
      tooltipOpacity={tooltipOpacity}
      setIsHovered={setIsHovered}
      backgroundColor={backgroundColor}
    >
      {children}
    </TooltipView>
  );
};

export default Tooltip;
